import { render, staticRenderFns } from "./TrainTickets.vue?vue&type=template&id=6e5f1579&scoped=true"
import script from "./TrainTickets.vue?vue&type=script&lang=js"
export * from "./TrainTickets.vue?vue&type=script&lang=js"
import style0 from "./TrainTickets.vue?vue&type=style&index=0&id=6e5f1579&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5f1579",
  null
  
)

export default component.exports